// NoPermission.js
import { CloseCircleFilled } from '@ant-design/icons'
import React from 'react'

const NoPermission = () => (
  <div
    style={{
      textAlign: 'center',
      padding: '2rem',
    }}
  >
    <CloseCircleFilled style={{ fontSize: 100, color: 'red' }} />
    <h1>Access Denied</h1>
    <p>
      You do not have permission to access this page.
      <br /> Contact an administrator to get permission.
    </p>
  </div>
)

export default NoPermission
